"POStatus".datatype()
"description".field({key: true})
"POStatus".data([
  {description: "Awaiting Delivery"},
  {description: "Partially Received"},
  {description: "Received"},
])
